const BASE_URL = process.env.REACT_APP_BASE_URL || "https://api-bus-intercept.test.wisr.tech";

export const EMAIL_SEND_ENDPOINT = `${BASE_URL}/api/email/send`;
